import { getAnalyticsBySnomed } from '../cms/analytics'

// NOTE: get the human readable text name of a biological sex from its ID
const getBiologicalSexName = (conceptId: any) => {
	switch (conceptId) {
		case '248153007':
			return 'Male'
		case '248152002':
			return 'Female'
		case '32570691000036108':
			return 'Intersex'
		default:
			return
	}
}

// NOTE: search for a concept in a list of snomed records by its ID
const getConceptById = async (conceptId: any) => {
	if (!conceptId) throw new Error('No concept ID provided')

	const response = await getAnalyticsBySnomed(conceptId)

	const json = await response.json()

	if (!response.ok) throw new Error(json.error)

	return json.data[0]
}

export {
	getBiologicalSexName,
	getConceptById
}
